import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { WalletPaymentProvider } from '@model/WalletPaymentProvider'

import { DepositTarget } from './types'

export const useDepositMethods = (params: {
  target: DepositTarget
  locale: string
  selectedWalletId?: string
  selectedTradingAccountWalletId?: string
}) => {
  const { target, locale, selectedWalletId, selectedTradingAccountWalletId } = params
  const apiClient = useApiClient(ClientApiClient)

  const walletId = target === 'wallet' ? selectedWalletId : selectedTradingAccountWalletId

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.deposit.methods(target, locale, walletId),
    queryFn: () => apiClient.getWalletDepositMethods(locale, walletId!),
    enabled: !!walletId,
  })

  return {
    methods: (data ?? []) as WalletPaymentProvider[],
    isMethodsLoading: isLoading,
  }
}
